import { setupInterceptorsTo } from './interceptor'
import axios from 'axios'
setupInterceptorsTo(axios)
